import { useRef, useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux"
import { Box, Typography, useTheme } from "@mui/material";
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import { tokens } from "../../assets/theme";
import { PowerembedReport } from "./powerbiembed";
import { selectSelectedReportDetails, selectSelectedReportId } from "../auth/authSlice"
import { selectUserData, selectIsAdminAnalytics, setReportFilters } from "../data/dataSlice"

const ReportDetails = () => {
  const dispatch = useDispatch()
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const columns = [
    {
      field: "name",
      headerName: "Main Asset",
      flex: 1,
      cellClassName: "name-column--cell",
    },
    {
      field: "actualconsumption",
      headerName: "Actual Consumption",
      flex: 1,
      renderCell: (params) => (
        <Box m="0px"><Typography color={colors.blueAccent[500]}>
          {params.row.actualconsumption}
        </Typography></Box>
      ),
    },
    {
        field: "referenceconsumption",
        headerName: "Reference Consumption",
        flex: 1,
        renderCell: (params) => (
          <Typography color={colors.grey[500]}>
            {params.row.referenceconsumption}
          </Typography>
        ),
      },
  ];

  const reportEmbeddObj = useSelector(selectSelectedReportDetails)
  const selectedReportId = useSelector(selectSelectedReportId)
  const userdata = useSelector(selectUserData)
  const isAdminAnalytics = useSelector(selectIsAdminAnalytics);
  const defaultlocale = {"languageId":"en","sortOrder":1,"language":"English","defaultCulture":"en-US"}
  const locale = userdata && userdata.language ? userdata.language : defaultlocale

  const reportEmbedData = {
    ReportId: selectedReportId ? selectedReportId : "",
    EmbedUrl: reportEmbeddObj && reportEmbeddObj.embedUrl ? reportEmbeddObj.embedUrl : "",
    EmbedToken: reportEmbeddObj && reportEmbeddObj.token ? reportEmbeddObj.token : "",
    ViewMode: reportEmbeddObj && reportEmbeddObj.userCanEdit ? true : false,
    locale: locale,
    OnlyCopy: reportEmbeddObj && reportEmbeddObj.name.toLowerCase().includes('_st_db_ecto_bi') ? true : false
  };

  return (
    <Box m="0px" className="reportdetailbox">
      <Box
        m="10px 0 0 0"
        height="75vh"
        className="reportDetailsChart"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .name-column--cell": {
            color: colors.grey[300],
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.blueAccent[700],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.primary[400],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.blueAccent[700],
          },
          "& .MuiCheckbox-root": {
            color: `${colors.grey[200]} !important`,
          },
        }}
      >
        <div id="report-container" className={isAdminAnalytics ? "report-container-admin" : "report-container-user"}></div>
        {PowerembedReport(reportEmbedData)}
      </Box>
      <div className="div-report-title"><AssessmentOutlinedIcon />{reportEmbeddObj && reportEmbeddObj.name ? reportEmbeddObj.name : ""}</div>
    </Box>
  );
};

export default ReportDetails;
